import { useCallback } from "react";
import { container } from "tsyringe";
import { XMarkIcon } from "@heroicons/react/20/solid";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";
import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import Modal from "components/elements/Modal";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { useProjectTeamContext } from "components/pages/ProfessionalSpace/contexts/ProjectTeam";
import { useProjectId } from "hooks/useProjectId";
import ContributorService from "services/projects/ContributorService";
import classes from "./classes.module.scss";

type IProps = {
	contributor: ContributorResponseResource;
	isOpen: boolean;
	onClose: () => void;
	onRemoved: (contributor: ContributorResponseResource) => void;
};

const contributorService = container.resolve(ContributorService);

export default function RemoveContributorModal(props: IProps) {
	const { projectId } = useProjectId();
	const { projectTeamId } = useProjectTeamContext();

	const onRemoveContributor = useCallback(() => {
		contributorService.delete(projectId, projectTeamId, props.contributor.id).then(() => props.onRemoved(props.contributor));
	}, [projectId, projectTeamId, props]);

	return (
		<Modal isOpen={props.isOpen} onClose={props.onClose} className={classes["root"]}>
			<div className={classes["header"]}>
				<Typography type="p" size="large" weight="bold">
					{I18n.asset.pages.professional_space.tabs.team.delete_member_modal.title}
				</Typography>
				<XMarkIcon className={classes["icon"]} onClick={props.onClose} />
			</div>

			<div className={classes["text-container"]}>
				<Typography type="p">
					{I18n.trslt(I18n.asset.pages.professional_space.tabs.team.delete_member_modal.text_1, {
						member: `${props.contributor.firstName} ${props.contributor.lastName}`,
					})}
				</Typography>
				<Typography type="p">{I18n.asset.pages.professional_space.tabs.team.delete_member_modal.text_2}</Typography>
			</div>

			<div className={classes["buttons-container"]}>
				<Button variant={EButtonVariant.TEXT} color={EButtonColor.PRIMARY} onClick={props.onClose}>
					{I18n.asset.pages.professional_space.tabs.team.delete_member_modal.cancel}
				</Button>
				<Button variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY} onClick={onRemoveContributor}>
					{I18n.asset.pages.professional_space.tabs.team.delete_member_modal.confirm}
				</Button>
			</div>
		</Modal>
	);
}
